var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [_vm._v("Balance")]),
      _c("br"),
      _vm._v(" "),
      _c("wallet-table", {
        attrs: { headList: _vm.headList, contentList: _vm.balanceList }
      }),
      _vm._v(" "),
      _c("br"),
      _c("div", [_vm._v("Unreceived")]),
      _c("br"),
      _vm._v(" "),
      _c("wallet-table", {
        attrs: { headList: _vm.headList, contentList: _vm.onroadList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }